export default ({ logger, obj, eventNames }) => {
  eventNames.forEach((eventName) => {
    obj.on(eventName, (...args) => logger.spam('emitted', eventName, args));
  });
};



// WEBPACK FOOTER //
// ./src/js/RaptorSession/logEvents.js